module.exports = __webpack_public_path__ + "img/new-not-found-wg.6c6cb72b.svg";